import axios from "axios";

// export const ip = `http://127.0.0.1:4000`;

export const ip = `https://api.pmdrivein.com:4000`;

export const callApi = async (url, method, data = null, params = null, headers = null) => {
  try {
    let headersToSend = {
      token: `${localStorage.getItem("token")}`,
      ...headers,
    };

    const config = {
      method: method,
      url: url,
      headers: headersToSend,
    };

    // Add params if they are provided
    if (params) {
      config.params = params;
    }

    // if data
    if (data) {
      config.data = data;
    }

    const response = await axios(config);
    return response;
  } catch (e) {
    throw e;
  }
};
